<div class="bn-details-header">
    <div class="bn-dtails-header-title">
        Billing details
    </div>
        <div class="bn-details-header-pol">
            <div class="bn-active-pol-label">{{billingPolicyData?.title}}</div>
            <div class="bn-drop-down">
                <div class="w-100" #ngSelectHost [ngClass]="{'ng-custom-select-acmic pb-0':isAcmic}">
                    <form [formGroup]="billingPolicySelectForm">
                        <ng-select 
                            [items]="billingPolicyData?.policyData" 
                            bindLabel="name" 
                            [autofocus]="false" 
                            bindValue="name" 
                            [searchable]="false" 
                            [multiple]="false"
                            [clearable]="false" 
                            [markFirst]="false" 
                            placeholder="Select one" 
                            fixedPlaceholder="true"
                            [dropdownPosition]="'bottom'"
                            [formControlName]="'selectedPolicy'"
                            [style.width.px]="!isAcmic ? selectHostWidth : null"
                            (change)="onPolicySelect()">
                            <ng-template ng-label-tmp let-item="item">
                              <div class="dropdown-item-container">
                                <ng-container *ngIf="!isAcmic; else acmicDropdownSelectedItem">
                                    <div class="policy-row">
                                      <span class="policy-col policy-type" [style.width.px]="colWidths[0]">
                                        <ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
                                        {{toSentenceCase(getPolicyTypeLabel(item.name) | lowercase | translate | replaceUnderscoreWithSpace)}}
                                      </span>
                                      <span class="policy-col policy-number" [style.width.px]="colWidths[1]">{{getPolicyNumberSuffix(item.name)}}</span>
                                      <span class="policy-col policy-term" [style.width.px]="colWidths[2]" *ngIf="item.effDate && item.expDate">{{item.effDate | date:'MM/dd/yy'}}-{{item.expDate | date:'MM/dd/yy'}}</span>
                                    </div>
                                </ng-container>

                                <ng-template #acmicDropdownSelectedItem>
                                  <ng-container>
                                    <div><ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
                                        {{item.name | lowercase | translate | replaceUnderscoreWithSpace}}</div>
                                  </ng-container>
                                  <ng-container *ngIf="item.effDate && item.expDate">
                                    <div>{{item.effDate | date:'MM/dd/yy'}} - {{item.expDate | date:'MM/dd/yy'}}</div>
                                  </ng-container>
                                </ng-template>
                              </div>
                            </ng-template>
                            <ng-template
                              ng-option-tmp
                              let-item="item"
                              let-index="index"
                            >
                              <div class="dropdown-item-container">
                                <ng-container *ngIf="!isAcmic; else acmicDropdownItem">
                                  <div class="policy-row">
                                    <span class="policy-col policy-type" [style.width.px]="colWidths[0]">
                                      <ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
                                      {{toSentenceCase(getPolicyTypeLabel(item.name) | lowercase | translate | replaceUnderscoreWithSpace)}}
                                    </span>
                                    <span class="policy-col policy-number" [style.width.px]="colWidths[1]">{{getPolicyNumberSuffix(item.name)}}</span>
                                    <span class="policy-col policy-term" [style.width.px]="colWidths[2]" *ngIf="item.effDate && item.expDate">{{item.effDate | date:'MM/dd/yy'}}-{{item.expDate | date:'MM/dd/yy'}}</span>
                                  </div>
                                </ng-container>

                                <ng-template #acmicDropdownItem>
                                  <ng-container>
                                    <div><ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
                                        {{item.name |lowercase | translate | replaceUnderscoreWithSpace}}</div>
                                  </ng-container>
                                    <ng-container *ngIf="item.effDate && item.expDate">
                                      <div>{{item.effDate | date:'MM/dd/yy'}} - {{item.expDate | date:'MM/dd/yy'}}</div>
                                    </ng-container>
                                </ng-template>
                              </div>
                            </ng-template> 
                        </ng-select>
                    </form>
                </div>
            </div>
        </div>
</div>

<div class="measure-table" *ngIf="!isAcmic" #measureHelper>
  <div class="measure-row" *ngFor="let item of billingPolicyData?.policyData">
      <span class="measure-cell measure-type">
        <ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
        {{toSentenceCase(getPolicyTypeLabel(item.name) | lowercase | translate | replaceUnderscoreWithSpace)}}
      </span>
      <span class="measure-cell measure-number">
          {{getPolicyNumberSuffix(item.name)}}
      </span>
      <span class="measure-cell measure-term" *ngIf="item.effDate && item.expDate">
        {{item.effDate | date:'MM/dd/yy'}}-{{item.expDate | date:'MM/dd/yy'}}
      </span>
  </div>
</div>